'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'peach';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e20b';
var svgPathData = 'M96 0L88 0l0 8 0 32c0 18.7 4.9 36.2 13.5 51.3c5.2-1.8 10.4-3.4 15.7-4.8C108.9 73 104 57.1 104 40l0-24 56 0c45.1 0 82.2 33.9 87.4 77.5c5.7 .6 11.5 .6 17.2 0C269.8 49.9 306.9 16 352 16l56 0 0 24c0 17.1-4.9 33-13.3 46.5c5.3 1.4 10.6 3 15.8 4.8C419.1 76.2 424 58.7 424 40l0-32 0-8-8 0L352 0c-43.2 0-80.3 26.4-96 63.9C240.3 26.4 203.2 0 160 0L96 0zM256 136.9c-25.6-15.8-55.7-24.9-88-24.9l-8 0 0 .2C70.9 116.4 0 189.9 0 280C0 432 248 512 248 512l16 0s248-80 248-232c0-92.8-75.2-168-168-168c-32.3 0-62.4 9.1-88 24.9zM283.4 156c-4-3.3-8.2-6.4-12.4-9.4c21.7-11.9 46.5-18.6 73-18.6c83.9 0 152 68.1 152 152c0 67-55.1 120.8-116.5 159.5c-30.1 18.9-60.2 33.3-83 42.9c-11.3 4.8-20.8 8.4-27.3 10.8c-3.3 1.2-5.8 2.1-7.6 2.7l-.2 .1-10.8 0-.2-.1c-1.7-.6-4.3-1.5-7.6-2.7c-6.6-2.4-16-6-27.3-10.8c-22.7-9.7-52.9-24-83-42.9C71.1 400.8 16 347 16 280c0-83.9 68.1-152 152-152c36.2 0 75.3 15.9 105.3 40.4c30.2 24.6 49.9 56.5 49.9 87.6l0 8 16 0 0-8c0-37.7-23.5-73.8-55.8-100z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;